export default __webpack_public_path__ + "static/media/logowhite.f2e491a3.svg";